import React from 'react';
import Iframe from 'react-iframe';
import {Container} from 'reactstrap'

class MiniGame extends React.Component {
    render() {
        return (
            <>
                <div className="iframesContainer">
                    <img alt="" className="background" src="https://o.aolcdn.com/images/dims?quality=85&image_uri=http%3A%2F%2Fo.aolcdn.com%2Fhss%2Fstorage%2Fmidas%2F1355decbdedf32d435d459f17db90415%2F205545750%2Fasteroids-main-dl.jpg&client=amp-blogside-v2&signature=3af6fe1e60ea3a6f3156b7e68e02f070ac4f2dde"/>
                    <Iframe src="https://arcade.giphy.com/playlist/LrKxoExY9YgaVeR6pxn" />
                    
                </div>
            </>
        )
    }
}
    
export default MiniGame;